// extracted by mini-css-extract-plugin
module.exports = {"content":"QuestionAnswerWebformTable_content__1hnDo","titleWrapper":"QuestionAnswerWebformTable_titleWrapper__2GCs1"};